<template>
  <div id="custom-table-list" class="custom-table-container">
    <category-view-sidebar
      v-if="sidebarData.id !== undefined"
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :category="sidebarData"
    />

    <category-view-sidebar
      v-else
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
    />

    <vs-table
      ref="table"
      multiple
      :sst="true"
      @sort="handleSort"
      @search="handleSearch"
      noDataText="Sem dados disponíveis"
      v-model="selected"
      search
      :data="categories"
    >
      <!-- HEADER -->
      <div slot="header" id="custom-header-wrapper">
        <HeaderList
          :itemsPerPage="itemsPerPage"
          @changeItemsPerPage="setItemsPerPage"
          @emitAddNewData="addNewData"
        />
      </div>
      <!-- FIM HEADER -->

      <template slot="thead">
        <vs-th>Imagem</vs-th>
        <vs-th sort-key="name">Nome</vs-th>
        <vs-th>Criado Em</vs-th>
        <vs-th>Atualizado Em</vs-th>
        <vs-th>Ativo</vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="whitespace-no-wrap">
              <a :href="tr.image_url" target="_blank" v-if="tr.image_url">
                <img :src="tr.image_url" alt="" :title="tr.image_url" width="64" height="64" />
              </a>
              
              <img
                v-else
                src="https://clean-code.s3.amazonaws.com/jornaldamanha/images/1611084839Sg6CYILJbM.png"
                alt=""
                title="Este caderno ainda não possui uma imagem representativa"
                width="64"
                height="64"
                style="background-color: #EFF0F2;"
              />
            </vs-td>
            
            <vs-td>
              <p class="product-name font-medium">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p class="font-medium">
                {{ formatStringDate(tr.created_at) }}
              </p>
            </vs-td>

            <vs-td>
              <p class="font-medium">
                {{ formatStringDate(tr.updated_at) }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-activated font-medium">
                <ActiveItem :active="tr.activated" />
              </p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(tr)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-pagination :total="totalPages" v-model="currentPage"></vs-pagination>
  </div>
</template>

<script>
  import ActiveItem from '@/components/ActiveItem'
  import CategoryViewSidebar from './CategoryViewSidebar'
  import HeaderList from '@/views/components/custom/HeaderList'

  import moduleCategory from '@/store/category/moduleCategory'
  import { defineSortFieldDirection, formatDate } from '@/utils'

  export default {
    name: 'categories-list',
    components: {
      CategoryViewSidebar,
      ActiveItem,
      HeaderList
    },
    data() {
      return {
        selected: [],
        itemsPerPage: 5,
        currentPage: 1,
        isMounted: false,
        addNewDataSidebar: false,
        sidebarData: {},
        searchField: null,
        sortField: {
          default: 'id_desc',
          current: '',
          count: 0
        }
      }
    },
    computed: {
      categories() {
        return this.$store.state.category.categories
      },
      totalPages() {
        return this.$store.state.category.totalPages
      }
    },
    watch: {
      currentPage() {
        this.handleChangePage()
      },
      itemsPerPage() {
        this.handleChangePage()
      }
    },
    methods: {
      addNewData() {
        this.sidebarData = {}
        this.toggleDataSidebar(true)
      },
      editData(data) {
        this.sidebarData = this.$_.cloneDeep(data)
        this.toggleDataSidebar(true)
      },
      toggleDataSidebar(val=false) {
        this.addNewDataSidebar = val
      },
      setItemsPerPage(qty) {
        this.currentPage = 1
        this.itemsPerPage = qty
        //this.fetchData()
      },
      handleSort(sort) {
        if (sort !== null) {
          this.sortField.count++

          if (this.sortField.count < 3) {
            this.sortField.current = defineSortFieldDirection(this.sortField.current, sort)
          } else {
            this.resetSortField()
          }
          
          this.fetchData()
        } else {
          if (this.sortField.current !== this.sortField.default) {
            this.resetSortField()
            this.fetchData()
          }
        }
      },
      resetSortField() {
        this.sortField.current = this.sortField.default;
        this.sortField.count = 0;
      },
      handleSearch(search) {
        let searchField = null

        if (search !== "") {
          searchField = {
            name: search
          }
        }
        
        this.searchField = searchField
        this.fetchData()
      },
      handleChangePage() {
        this.fetchData()
      },
      fetchData() {
        if (moduleCategory.isRegistered) {
          this.$store.dispatch("category/fetch", {
            ...this.searchField, 
            ...{ order_by: this.sortField.current },
            ...{ pagination_page: this.currentPage, pagination_limit: this.itemsPerPage }
          })
        }
      },
      formatStringDate(date) {
        return formatDate(date).full
      }
    },
    created() {
      this.resetSortField();

      if (!moduleCategory.isRegistered) {
        this.$store.registerModule('category', moduleCategory)
        moduleCategory.isRegistered = true
      }
      
      this.fetchData();
    },
    mounted() {
      this.isMounted = true;
    }
  }
</script>